import { configureStore } from '@reduxjs/toolkit';
import blogReducer from "./slice/blogSlice";
import inquiryReducer  from './slice/inquirySlice';
import distributionReducer from "./slice/distributionSlice";
import medicineReducer from "./slice/medicineSlice";

const store = configureStore({
  reducer: {
    blogs: blogReducer,
    distribution:distributionReducer,
    inquiry:inquiryReducer,
    medicine:medicineReducer,
  },
})


export default store;